import { useEffect, useState } from 'react';
import type { UnlockedSession } from '@argos/auth-client';
import { getSession, subscribeSession } from '../auth/session';

/** React hook around the session pub-sub. Returns null when locked. */
export function useSession(): UnlockedSession | null {
  const [s, setS] = useState<UnlockedSession | null>(getSession());
  useEffect(() => subscribeSession(setS), []);
  return s;
}
